import CreaturePane from './CreaturePane';

export default CreaturePane;
export { CreaturePane };
